module.exports = __webpack_public_path__ + "img/logo_white.7e23e03e.png";